import {
    ASSIGNED_ISSUE_APPROVAL,
    CREATE_ISSUE_REQUEST,
    DELETE_FILE_ISSUE_REQUEST,
    DELETE_ISSUE_REQUEST,
    GET_ISSUE_APPROVAL_LIST,
    GET_ISSUE_DETAIL_LIST,
    GET_ISSUE_MANAGER_LOG,
    GET_ISSUE_REQUEST_LIST,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    UPDATE_ISSUE_CLOSE,
    UPDATE_ISSUE_COMPLETE,
    UPDATE_ISSUE_REQUEST,
    UPDATE_ISSUE_STATUS,
} from "shared/constants/ActionTypes";
const initialState = {
    loading: true,
    error: null,
    issueRequestList: [],
    issueDetailList: {},
    issueApprovalList: [],
    issueManagerLogList: [],
    issueAssignedApprovalList: [],
};

const handleIssueDetails = (oldState, payload) => {
    let myOldState = { ...oldState };
    if (myOldState.id === payload.rowId) {
        return {
            ...myOldState,
            issuesImages: myOldState.issuesImages.filter(
                (file) => file.id !== payload.fileId
            ),
        };
    }
    return myOldState;
};

export const issueManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return { ...state, loading: true };
        case FETCH_SUCCESS:
            return { ...state, loading: false };
        case FETCH_ERROR:
            return { ...state, error: action.payload, loading: false };
        case GET_ISSUE_REQUEST_LIST:
            return {
                ...state,
                issueRequestList: action.payload,
            };
        case DELETE_FILE_ISSUE_REQUEST:
            return {
                ...state,
                issueRequestList: [
                    ...state.issueRequestList.map((item) => {
                        if (item.id === action.payload.rowId) {
                            item.issuesImages = [
                                ...item.issuesImages.filter(
                                    (file) => file.id !== action.payload.fileId
                                ),
                            ];
                        }
                        return item;
                    }),
                ],
                issueDetailList: handleIssueDetails(
                    state.issueDetailList,
                    action.payload
                ),
            };

        case GET_ISSUE_APPROVAL_LIST:
            return {
                ...state,
                issueApprovalList: action.payload,
            };
        case ASSIGNED_ISSUE_APPROVAL:
            return {
                ...state,
                issueAssignedApprovalList: action.payload,
            };

        case GET_ISSUE_MANAGER_LOG:
            return {
                ...state,
                issueManagerLogList: action.payload,
            };
        case CREATE_ISSUE_REQUEST:
            return {
                ...state,
                issueRequestList: [action.payload, ...state.issueRequestList],
            };
        case UPDATE_ISSUE_REQUEST:
            return {
                ...state,
                issueRequestList: [
                    ...state.issueRequestList.map((item) =>
                        item.id === action.payload.id
                            ? { ...action.payload.data }
                            : item
                    ),
                ],
                issueDetailList:
                    state.issueDetailList.id == action.payload.data.id
                        ? {
                              ...action.payload.data,
                          }
                        : state.issueDetailList,
            };
        case UPDATE_ISSUE_COMPLETE:
            return {
                ...state,
                issueRequestList: [
                    ...state.issueRequestList.map((item) =>
                        item.issueNo === action.payload.issueNo
                            ? { ...action.payload }
                            : item
                    ),
                ],
                issueDetailList:
                    state.issueDetailList.issueNo == action.payload.issueNo
                        ? {
                              ...action.payload,
                          }
                        : state.issueDetailList,
            };
        case UPDATE_ISSUE_CLOSE:
            return {
                ...state,
                issueApprovalList: [
                    ...state.issueApprovalList.filter(
                        (el) => el.issueNo !== action.payload.issueNo
                    ),
                ],
                issueDetailList:
                    state.issueDetailList.issueNo == action.payload.issueNo
                        ? {
                              ...action.payload,
                          }
                        : state.issueDetailList,
            };
        case DELETE_ISSUE_REQUEST:
            return {
                ...state,
                issueRequestList: state.issueRequestList.filter(
                    (el) => el.id !== action.payload.id
                ),
            };
        case GET_ISSUE_DETAIL_LIST:
            return {
                ...state,
                issueDetailList: action.payload,
            };
        case UPDATE_ISSUE_STATUS:
            return {
                ...state,
                issueApprovalList: [
                    ...state.issueApprovalList.map((item) =>
                        item.issueNo === action.payload.issueNo
                            ? { ...action.payload }
                            : item
                    ),
                ],
                issueAssignedApprovalList: [
                    ...state.issueAssignedApprovalList.map((item) =>
                        item.issueNo === action.payload.issueNo
                            ? { ...action.payload }
                            : item
                    ),
                ],
                issueDetailList:
                    state.issueDetailList.issueNo === action.payload.issueNo
                        ? {
                              ...action.payload,
                          }
                        : state.issueDetailList,
            };
        default:
            return state;
    }
};
